import { motion } from "framer-motion";
import { CheckCircle2, XCircle } from "lucide-react";
import { FOR_WHOM_YES, FOR_WHOM_NO } from "./data";
import { FloatingMoon, FloatingCloud, Sparkle } from "./SleepDecorations";
import { LANDING } from "@/constants/testIds";

export default function ForWhomSection() {
  return (
    <section className="relative py-28 bg-[#f5eff8] overflow-hidden">
      {/* Soft baby-sleep decorations */}
      <FloatingCloud
        className="absolute -top-6 -left-10 text-[#a78bfa] drift-slow"
        size={200}
      />
      <FloatingMoon
        className="absolute top-8 right-[-40px]"
        size={200}
        tone="dark"
      />
      <Sparkle className="absolute top-[40%] left-[5%] text-violet-500" size={22} />
      <Sparkle className="absolute bottom-[20%] right-[12%] text-[#a78bfa]" size={28} />
      <FloatingCloud
        className="absolute bottom-0 right-[-30px] text-[#6d28d9] drift-slow"
        size={180}
      />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="text-center max-w-3xl mx-auto mb-14"
        >
          <h2 className="font-display text-4xl lg:text-5xl text-[#1a0a2e] leading-[1.1]">
            Essa Jornada foi feita para um perfil específico de mãe.
            <span className="block text-[#6d28d9] font-semibold mt-3 tracking-tight">
              VEJA SE É VOCÊ.
            </span>
          </h2>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-6 items-stretch">
          <motion.div
            data-testid={LANDING.forWhomYes}
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="h-full rounded-3xl border border-emerald-300/40 bg-white/80 backdrop-blur-md p-8 lg:p-10 shadow-[0_25px_70px_-20px_rgba(16,185,129,0.25)]"
          >
            <div className="flex items-center gap-3 mb-7">
              <div className="w-12 h-12 rounded-full bg-emerald-100 flex items-center justify-center">
                <CheckCircle2 className="w-6 h-6 text-emerald-600" />
              </div>
              <h3 className="font-display text-2xl lg:text-3xl text-[#1a0a2e]">
                Para quem é
              </h3>
            </div>
            <ul className="space-y-4">
              {FOR_WHOM_YES.map((item, i) => (
                <li
                  key={i}
                  className="flex gap-3 text-slate-700 text-[15px] leading-relaxed"
                >
                  <CheckCircle2
                    className="w-5 h-5 text-emerald-600 shrink-0 mt-0.5"
                    strokeWidth={2}
                  />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </motion.div>

          <motion.div
            data-testid={LANDING.forWhomNo}
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.1 }}
            className="h-full rounded-3xl border border-rose-300/40 bg-white/80 backdrop-blur-md p-8 lg:p-10 shadow-[0_25px_70px_-20px_rgba(244,63,94,0.18)]"
          >
            <div className="flex items-center gap-3 mb-7">
              <div className="w-12 h-12 rounded-full bg-rose-100 flex items-center justify-center">
                <XCircle className="w-6 h-6 text-rose-600" />
              </div>
              <h3 className="font-display text-2xl lg:text-3xl text-[#1a0a2e]">
                Para quem não é
              </h3>
            </div>
            <ul className="space-y-4">
              {FOR_WHOM_NO.map((item, i) => (
                <li
                  key={i}
                  className="flex gap-3 text-slate-600 text-[15px] leading-relaxed"
                >
                  <XCircle
                    className="w-5 h-5 text-rose-500 shrink-0 mt-0.5"
                    strokeWidth={2}
                  />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
